import { ritiroDelRicambio } from "../../sostituzione";
import type { Order } from "../../types";
import { BTN, BTN_ICON } from "./stile";

type Props = { order: Order; busy: boolean; onSend: (o: Order) => Promise<void> };

/** «Invia LDV» nella pagina ordine, nello stile dei tasti della griglia
 *  Spedizione (bordo, testo nero, icona da 2xl). Nella lista resta la
 *  tessera compatta di ``PickupMailButton``: qui c'è spazio per la parola. */
export function InviaLdvButton({ order, busy, onSend }: Props) {
  const giaInviata = order.pickupMailSent === true;
  const ricambio = ritiroDelRicambio(order);
  return (
    <button
      type="button"
      disabled={busy}
      aria-busy={busy}
      aria-label={
        busy
          ? "Invio LDV in corso…"
          : giaInviata
            ? "Reinvia mail LDV (gia' inviata)"
            : ricambio
              ? "Invia LDV del ricambio"
              : "Invia LDV"
      }
      title={
        giaInviata
          ? "Mail LDV già inviata al fornitore: clicca per rimandarla"
          : ricambio
            ? "Prepara la mail di ritiro del ricambio, con l'etichetta della sostituzione allegata (mai la LDV originale), da rileggere prima dell'invio"
            : "Prepara la mail di spedizione al fornitore, con la LDV allegata, da rileggere prima dell'invio"
      }
      onClick={() => void onSend(order)}
      className={`${BTN} w-full text-center leading-tight`}
    >
      <svg viewBox="0 0 24 24" className={`hidden 2xl:block ${BTN_ICON}`} aria-hidden="true">
        <path d="M4 4h16v16H4z" />
        <path d="m4 7 8 6 8-6" />
      </svg>
      {busy
        ? "Preparo…"
        : giaInviata
          ? "Reinvia LDV"
          : ricambio
            ? "Invia LDV ricambio"
            : "Invia LDV"}
    </button>
  );
}
